import styled from '@emotion/styled'

import { colors } from 'component-library/__styling/settings'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions/'
import { breakWords } from 'component-library/__styling/style-mixins'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledHeading = styled('h1')(({ theme }) => ({
    ...breakWords,

    fontWeight: theme.kind === 'thewest' ? 600 : 700,
    fontFamily: theme.fonts.heading,

    fontSize: themedValue(theme, {
        thewest: calcRem(26),
        fallback: calcRem(24),
    }),

    lineHeight: themedValue(theme, {
        thewest: 1.158,
        fallback: 1,
    }),

    textTransform: themedValue(theme, {
        thewest: undefined,
        fallback: 'uppercase' as 'uppercase',
    }),
    color: themedValue(theme, {
        thewest: colors.black,
        perthnow: colors.perthnow.greyCoal,
        sevennews: colors.sevennews.charade,
    }),
    marginTop: themedValue(theme, {
        thewest: calcRem(14),
        fallback: 0,
    }),
    marginBottom: themedValue(theme, {
        thewest: calcRem(14),
        fallback: 0,
    }),

    [breakpoint('sm')]: {
        fontSize: themedValue(theme, {
            thewest: calcRem(38),
            fallback: calcRem(36),
        }),
    },
}))
StyledHeading.displayName = 'StyledHeading'
